import { BannerNotification } from '@hologram-dimension/banner-notification';
import { Button } from '@hologram-dimension/button';
import { Modal } from '@hologram-dimension/modal';
import { useState, type FC } from 'react';
import styles from './TagDeleteConfirmation.module.css';
import { TagManagerTag } from './types';

interface TagDeleteConfirmationProps {
  tag: TagManagerTag;
  onConfirmed: () => void;
  onCancelled: () => void;
}

// TODO: We will probably need more confirmation dialogs in the future, consider refactoring this into a generic confirmation dialog

const TagDeleteConfirmation: FC<TagDeleteConfirmationProps> = ({
  tag,
  onConfirmed,
  onCancelled,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Modal
      defaultOpen
      open={isOpen}
      setOpen={setIsOpen}
      onClosed={onCancelled}
      header="Delete tag?"
      footerActions={
        <>
          <Button variant="secondary" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button variant="delete" onClick={onConfirmed}>
            Yes, delete tag
          </Button>
        </>
      }
    >
      <div className={styles.contents}>
        Are you sure you want to delete the tag “{tag.name}”?
        {(tag.sims?.length ?? 0) === 0 && ' It has not been added to any SIMs.'}
        {(tag.sims?.length ?? 0) > 0 && (
          <BannerNotification variant="caution">
            “{tag.name}” will be removed from {tag.sims!.length}{' '}
            {tag.sims!.length === 1 ? 'SIM' : 'SIMs'}.
          </BannerNotification>
        )}
      </div>
    </Modal>
  );
};

export default TagDeleteConfirmation;
